




















import {Component, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {Task, Photo} from '@/store/types'
import TaskPhotosList from './TaskPhotosList.vue'

@Component({
  components: {
    TaskPhotosList,
  },
})
export default class TaskPhotos extends Vue {
  @Getter ('task') public task!: Task
  @Getter ('photos') public photos!: Photo[]
  @Action ('addNewPhoto') public addNewPhoto!: any

  public addPhoto() {
    const addPhotoInput = document.getElementById('add-photo-input')
    if (addPhotoInput) {
      addPhotoInput.click()
    }
  }

  public uploadPhoto(files: any) {
    this.addNewPhoto(files)
  }
}
